export const COLUMNS = [
  { id: 'name', label: 'Вопрос', minWidth: 450 },
  {
    id: 'population',
    label: 'Действия',
    minWidth: 50,
  },
];
